import React from 'react';
import { Link } from 'react-router-dom';
import './AppComponents.css';

// ServiceCard component for rendering app cards on landing page
function ServiceCard({ app }) {
  const CardContent = () => (
    <>
      <span className="service-icon">{app.icon}</span>
      <h2 className="service-title">{app.name}</h2>
      <p className="service-description">{app.description}</p>
    </>
  );

  if (app.external) {
    return (
      <a href={app.route} className="service-card" target="_blank" rel="noopener noreferrer" aria-label={app.name}>
        <CardContent />
      </a>
    );
  }

  return (
    <Link to={app.route} className="service-card" aria-label={app.name}>
      <CardContent />
    </Link>
  );
}

// BackButton component for consistent navigation
function BackButton({ to = "/" }) {
  return (
    <Link to={to} className="back-button" aria-label="Back to Home">
      ← Back to Home
    </Link>
  );
}

// AppHeader component for consistent app headers
function AppHeader({ title, user, subtitle, actions, showBackButton = false }) {
  const greeting = user
    ? `Welcome back, ${user.name?.split(' ')[0] || user.username || 'User'}`
    : null;

  return (
    <header className="app-header" role="banner">
      {showBackButton && (
        <nav className="app-header-nav" aria-label="App navigation">
          <BackButton />
        </nav>
      )}
      <div className="app-header-row">
        <div className="app-header-text">
          <h1>{title}</h1>
          {(subtitle || greeting) && (
            <p className="app-header-subtitle">{subtitle || greeting}</p>
          )}
        </div>
        {actions && <div className="app-header-actions">{actions}</div>}
      </div>
    </header>
  );
}

export { ServiceCard, BackButton, AppHeader };